import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private static promise: Promise<void> | null = null;
  private readonly apiKey = 'AIzaSyDDJe1T-YdzbijnuMUFVe_ZLAmvpoj6wB4';

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    if (GoogleMapsLoaderService.promise) {
      return GoogleMapsLoaderService.promise;
    }

    GoogleMapsLoaderService.promise = new Promise<void>((resolve, reject) => {
      if (typeof google !== 'undefined' && google.maps) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = (error) => {
        console.error('Google Maps failed to load', error);
        reject(error);
      };

      document.head.appendChild(script);
    });

    return GoogleMapsLoaderService.promise;
  }
}
